<template>
  <section>
    <PublicNavigation :showForm="showForm" />
    <!-- Main header -->
    <section class="main-header">
      <div class="container d-flex align-items-center">
        <div class="col-md-6 container-col">
          <div>
            <h1>Tech Recruiting as a Service</h1>
            <p class="mb-5 mt-3">
              Explore our innovative solution combining a top-modern recruiting platform with access
              to personal headhunting and other professional services.
            </p>
            <router-link @click.native="showFormEvent('employer')" to class="btn btn-secondary mt-2"
              >Recruit Developers</router-link
            >
            <router-link
              to
              @click.native="showFormEvent('employer')"
              class="btn btn-secondary ml-3 mt-2"
              >Register Account</router-link
            >
          </div>
          <ul class="list-inline">
            <li class="list-inline-item">✓ Headhunting</li>
            <li class="list-inline-item">✓ Social Recruiting</li>
            <li class="list-inline-item">✓ Success-based model</li>
          </ul>
        </div>
      </div>
    </section>
    <!-- Main header end -->
    <!-- about section -->
    <section class="about">
      <div class="container">
        <div class="row grey">
          <div class="col-md-10 mx-auto">
            <h4>
              Join over 200 tech companies and discover the benefits of using Jobshark for tech
              recruiting in the cloud
            </h4>

            <carousel
              :autoplay="true"
              :nav="false"
              :items="8"
              :margin="40"
              :autoplayTimeout="1000"
              :responsive="{
                0: { items: 2, nav: false },
                576: { items: 3, nav: false },
                768: { items: 3, nav: false },
                992: { items: 4, nav: false },
                1200: { items: 7, nav: false },
              }"
            >
              <img
                v-for="brand in brands"
                :key="brand.id"
                class="lgx-logo-img"
                :src="require(`../../../public/img/homepage/customer-logos/${brand.src}`)"
                style="max-width: 350px; max-height: 350px"
                :alt="brand.alt"
                :title="brand.alt"
              />
            </carousel>
          </div>
        </div>
      </div>
    </section>

    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              WHAT MAKES JOBSHARK DIFFERENT?
            </h2>
            <p class="title-text">
              Times have changed and it’s likely that you have experienced that job posting is
              simply not enough to attract interest from the best IT professionals. The alternative
              is to contract a traditional recruiting agency that is (hopefully) able to present a
              few headhunted candidates after a rather long-lasting and expensive process.
            </p>
            <p class="title-text">
              Jobshark offers a simpler solution. It combines a user-friendly recruiting platform
              with personal services such as headhunting, qualification and interviewing of
              candidates. And the best part is, you choose which of these services you want to use.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!--     <section class="statistics">
      <div class="container">
        <div class="row">
          <div class="col-md-11 mx-auto">
            <ul class="list-inline d-flex justify-content-between">
              <li
                v-for="(competence, index) in topCompetences"
                v-bind:key="competence.id"
                class="list-inline-item d-flex align-items-center"
              >
                <div class="text">
                  <i
                    v-if="competence.devicon !== null"
                    :class="`${competence.devicon} colored`"
                  ></i>
                  <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
                  <span>
                    <number
                      animationPaused
                      :ref="`col${index}`"
                      :format="theFormat"
                      :to="competence.counter"
                      :duration="3"
                      easing="Power1.easeOut"
                      @complete="completed"
                      @click="playAnimation(`col${index}`)"
                    />
                  </span>
                  <IntersectionObserver
                    v-if="index === 0"
                    sentinal-name="sentinal-name"
                    @on-intersection-element="onIntersectionElement"
                  ></IntersectionObserver>
                  {{ competence.name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section> -->

    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              HOW DOES IT WORK?
            </h2>
            <p class="title-text">
              It’s very easy to start using us for your tech recruitment projects. These are the
              basic steps:
            </p>
          </div>
          <div class="boxes">
            <div class="col-md-9 mx-auto">
              <div class="how-box">
                <div class="row">
                  <div class="col-md-4">
                    <div class="text">
                      <h2>Register an account in Jobshark</h2>
                      <p>
                        Registering into Jobshark is quick and easy, it only takes a minute.
                      </p>
                      <span class="count">1</span>
                    </div>
                  </div>
                  <div class="col-md-6 ms-auto">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/register-profile.png"
                      alt="Jobshark logo"
                    />
                  </div>
                </div>
              </div>

              <div class="how-box">
                <div class="row">
                  <div class="col-md-6">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/6.png"
                      alt="Jobshark logo"
                    />
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="text">
                      <h2>Post your job ad</h2>
                      <p>
                        During this process you choose which of our professional services
                        (headhunting, qualifying/interviewing candidates, etc.) you’d want to use.
                      </p>
                      <span class="count">2</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="how-box" style="margin-top:-20px">
                <div class="row">
                  <div class="col-md-4">
                    <div class="text">
                      <h2>Receive qualified candidates</h2>
                      <p>
                        The qualified candidates are delivered to you through our platform. If you
                        are using our interviewing service, you receive a written presentation of
                        each suitable candidate besides CV and other information.
                      </p>
                      <span class="count">3</span>
                    </div>
                  </div>
                  <div class="col-md-6 ms-auto">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/candidates.jpg"
                      alt="Jobshark logo"
                    />
                  </div>
                </div>
              </div>

              <div class="how-box mb-0">
                <div class="row">
                  <div class="col-md-6">
                    <img
                      class="img-fluid"
                      style="margin-top: -35px;"
                      src="/img/3.jpg"
                      alt="Jobshark logo"
                    />
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="text">
                      <h2>Manage the candidates</h2>
                      <p>
                        You easily manage the recruitment process within our platform and we can
                        also help out to book meetings, check qualifications, etc.
                      </p>
                      <span class="count">4</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--End of about -->

    <!-- Recruitment section -->
    <section class="recruitment">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto text-center">
            <button
              @click="showFormEvent('employer')"
              class="btn btn-secondary mb-5"
              style="display: block; width: 200px; padding: 12px; margin: 20px auto"
            >
              Get Started
            </button>
            <h2>
              WHAT PROFESSIONAL<br />
              SERVICES DO WE OFFER?
            </h2>
            <p>
              With our professional services, you are benefiting from the powerful combination of
              our tech recruiters who personally approach suitable candidates throughout our
              extensive network. And everything is delivered through and powered by Jobshark, our
              proprietary recruiting platform.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <img
              class="img-fluid"
              src="../../../public/img/homepage/img-services.png"
              alt="services"
            />
          </div>
          <div class="col-md-6">
            <ul class="list-unstyled">
              <li class="first">Our professional services include:</li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Composing job ads
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Headhunting (own and external databases)
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Social recruiting
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Advertising
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Initial screening
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                In-depth qualification
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                On-line programming tests for developers
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Arranging customer meetings
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Verifying references and other background checks
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                International search
              </li>
              <li>
                <div class="icon"><i class="fas fa-check"></i></div>
                Obtaining/renewing working permits
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mx-auto text-center mt-5">
            <p>
              You get to choose which steps of the hiring process we handle. Perhaps it’s enough if
              we source (headhunt and pre-screen) the candidates, and you conduct the initial
              interviews. Together, we offer a smooth recruitment process for candidates.
            </p>
            <img
              class="img-fluid mt-4"
              src="https://jobshark.eu/img/nodes.png"
              alt="managed services"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="about">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              The most common tech competencies amongst our registered candidates:
            </h2>
            <p class="title-text">
              We have our own roots in the software industry and our network consists of 100,000+ IT
              professionals with over 400 competencies in their portfolios. Most of them are based
              in Eastern Europe. They cover all major software development areas including .NET,
              Java, JavaScript, PHP, Kotlin, Swift, etc. We can also connect you with skilled
              freelancers in other areas such as DevOps, QA, design, technical support, and
              technical sales.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="statistics">
      <div class="container">
        <div class="row">
          <div class="col-md-11 mx-auto">
            <ul class="list-inline d-flex justify-content-between">
              <li
                v-for="(competence, index) in topCompetences"
                v-bind:key="competence.id"
                class="list-inline-item d-flex align-items-center"
              >
                <div class="text">
                  <i
                    v-if="competence.devicon !== null"
                    :class="`${competence.devicon} colored`"
                  ></i>
                  <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
                  <span>
                    <number
                      animationPaused
                      :ref="`col${index}`"
                      :format="theFormat"
                      :to="competence.counter"
                      :duration="3"
                      easing="Power1.easeOut"
                      @complete="completed"
                      @click="playAnimation(`col${index}`)"
                    />
                  </span>
                  <IntersectionObserver
                    v-if="index === 0"
                    sentinal-name="sentinal-name"
                    @on-intersection-element="onIntersectionElement"
                  ></IntersectionObserver>
                  {{ competence.name }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="table-section">
      <div class="container">
        <div class="row">
          <div class="col-md-8 mx-auto text-center">
            <h2>
              WHAT DOES IT COST TO USE<br />
              JOBSHARK?
            </h2>
            <p>
              We are happy to offer a very competitive pricing compared with traditional recruiting
              agencies. Advertising with us is entirely free and if you want to enjoy our
              professional services, cost is mainly success-based. Also, we don’t require to be
              exclusive for your recruiting projects.
            </p>
            <p>These are our different commercial plans:</p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-8 mx-auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col" style="width:45%">#</th>
                  <th scope="col">Basic</th>
                  <th scope="col">Sourcing</th>
                  <th scope="col">Full-Service</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th scope="row">
                    Job Promotion
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="Your job ad will be featured on Jobshark and promoted through our partner network. Jobshark is a fast-growing community where IT professionals and employers meet.

"
                      >?</a
                    >
                  </th>
                  <td><i class="fas fa-check"></i></td>
                  <td><i class="fas fa-check"></i></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    Headhunting / Social Recruiting
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="Our experienced recruiters will personally reach out to suitable candidates to introduce your open position. Our network comprises over 100,000 IT professionals, and we also reach out to candidates through social media and online tech communities.
"
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    Initial Qualification
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="We will evaluate whether the candidate's skills, background, and expectations meet the requirements for the position. The candidate must also adhere to other conditions, such as office policies, to proceed to the next stage."
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    In-depth Qualification / Interviewing
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="Our experienced tech recruiters conduct interviews with the candidates who have reached this stage to assess both their technical and soft skills. We provide you with a report about each candidate who passes, in addition to their CV and other information."
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    Online Programming Tests
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="We can set up an online programming test tailored to your specific technical prerequisites. The tests are time-limited (usually 1-3 hours) and carried out on a third-party online platform to ensure impartiality and enable comparison with other developers. We use rigorous anti-plagiarism tools to prevent cheating.
"
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    Arrange Meetings
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="With Jobshark, you always get verified contact details for all presented candidates. We are also happy to help arrange meetings with qualified candidates if you prefer.
"
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">
                    Reference Checking
                    <a
                      tabindex="0"
                      class="spanner"
                      role="button"
                      data-bs-toggle="popover"
                      data-bs-trigger="focus"
                      data-bs-content="Our experienced recruiters can conduct reference checks with previous employers and colleagues. You will receive a report for the reference checks. Alternatively, you can request us to provide you with suitable references who are expecting to be contacted by you."
                      >?</a
                    >
                  </th>
                  <td></td>
                  <td></td>
                  <td><i class="fas fa-check"></i></td>
                </tr>
                <tr>
                  <th scope="row">Fee Structure</th>
                  <td>Free</td>
                  <td colspan="2">Success-Based</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 mx-auto">
            <div class="reviews">
              <carousel :autoplay="true" :nav="false" :items="1" :autoplayTimeout="10000">
                <div v-for="review in reviews" :key="review.id" class="review-item">
                  <p>{{ review.review }}</p>
                  <span>{{ review.company }}</span>
                </div>
              </carousel>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--End of recruitment -->
    <!-- Middle Orange Section -->
    <section class="what-we-offer">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="intro">
              <h2>
                BENEFITS OF USING<br />
                JOBSHARK
              </h2>
              <p>
                We provide growth companies with suitable, high-performing candidates.
              </p>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-25.png`)" />
              </div>
              <h3>Tech Recruiting as a Service</h3>
              <p>
                We combine our leading proprietary recruiting platform with professional services
                into a unique tech recruiting service in the cloud
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-24.png`)" />
              </div>
              <h3>Convenient and Efficient</h3>
              <p>
                Customers are enjoying substantial time- savings by handing over qualification of
                candidates to us.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-09.png`)" />
              </div>
              <h3>Proactive and Professional</h3>
              <p>
                As we are experts in headhunting and social recruiting, we can attract interest from
                IT professionals that are normally extremely hard to reach.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-17.png`)" />
              </div>
              <h3>Success-Based Pricing</h3>
              <p>
                Success-based fee models and we don’t require to be exclusive.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-19.png`)" />
              </div>
              <h3>Smooth Collaboration</h3>
              <p>
                Collaboration with us is greatly simplified through our platform.
              </p>
            </div>
          </div>

          <div class="col-md-4">
            <div class="text-box">
              <div class="icon">
                <img :src="require(`../../../public/img/landing-pages/Icon-22.png`)" />
              </div>
              <h3>Applicant Tracking Features</h3>
              <p>
                The platform provides unique features for monitoring and managing the recruiting
                processes including dashboards, interactive pipelines, on-the-fly email integration,
                etc
              </p>
            </div>
          </div>
          <div class="text-center mb-5">
            <button
              @click="showFormEvent('employer')"
              class="btn btn-secondary"
              style="padding-left:50px; padding-right:50px"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="mid-section">
      <div class="container">
        <div class="row">
          <div class="col-md-9 mx-auto">
            <h2>
              SEVEN TIPS ON HOW TO SUCCEED IN TECH RECRUITING: <br />NAVIGATING THE MODERN WORK
              LANDSCAPE
            </h2>
            <p>
              Attracting the right IT talent is a daunting yet vital task for the growth of any tech
              company. The key to successful IT recruitment lies beyond just posting job ads; it
              requires a strategic approach to attract, engage, and retain top talent amid stiff
              competition. The best approach is often to combine different strategies based on the
              characteristics of each open position.
            </p>
            <p>
              This whitepaper unveils seven tips for succeeding in recruiting a high-performing tech
              team, offering insights into modern recruitment challenges and practical advice to
              enhance your hiring process. It's an essential read for anyone looking to refine their
              approach to tech recruiting.
            </p>
            <div class="mx-auto col-md-4">
              <a
                target="_blank"
                href="https://jobshark.eu/whitepapers/How_to_Recruit_Top_IT_Professionals.pdf"
                download="How to Recruit Top IT Professionals.pdf"
                class="btn btn-secondary"
                >Download Full Report</a
              >
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="what-we-offer">
      <div class="container">
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="intro">
              <h2>FREQUENTLY ASKED QUESTIONS</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mx-auto">
            <div class="accordion" id="accordionPanelsStayOpenExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseOne"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseOne"
                  >
                    Why makes Jobshark different than posting my open position at a job board?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseOne"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingOne"
                >
                  <div class="accordion-body">
                    Jobshark is something totally different than a traditional job board, as we
                    combine our easy- to-use platform with personal services such as headhunting and
                    qualification of candidates conducted by our renowned recruitment specialists.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseTwo"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseTwo"
                  >
                    Why shouldn’t I use a traditional recruitment agency instead of Jobshark?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingTwo"
                >
                  <div class="accordion-body">
                    It is true that many recruitment agencies have experienced tech recruiters as
                    well, but Jobshark makes the entire process much smoother and more efficient for
                    both you and candidates through our easy-to-use platform. Also, we work mainly
                    success-based and don’t require to be exclusive.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseThree"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseThree"
                  >
                    What type of technical expertise can you find?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseThree"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingThree"
                >
                  <div class="accordion-body">
                    We are totally focused on tech recruitment and our community of IT professionals
                    covers over 400 competencies. This includes backend developers proficient in
                    PHP, .NET, C#, Python, Ruby, Golang, and Java, as well as frontend developers
                    experienced in React.js, Vue.js, and Angular, etc. Additionally, we have many
                    web designers, QA specialists, DevOps Engineers, BI experts, technical support
                    specialists, etc in our network.
                  </div>
                </div>
              </div>

              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFour"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseFour"
                  >
                    What are the main differences between the Sourcing and Full-service plans:
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseFour"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingFour"
                >
                  <div class="accordion-body">
                    Our experienced tech recruiters headhunt and qualify candidates with both plans.
                    The difference is mainly that we conduct personal interviews with candidates if
                    you choose the full-service plan. With the sourcing plan, you conduct the first
                    real interview yourself.
                  </div>
                </div>
              </div>
            </div>

            <div class="accordion" id="accordionPanelsStayOpenExample">
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingFive">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseFive"
                    aria-expanded="true"
                    aria-controls="panelsStayOpen-collapseFive"
                  >
                    How do you conduct headhunting?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseFive"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingFive"
                >
                  <div class="accordion-body">
                    We are using modern channels such as different social media platforms but also
                    tech-specific communities. Besides that, our existing network of IT
                    Professionals consists of more than 100,000 IT professionals.
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h2 class="accordion-header" id="panelsStayOpen-headingSix">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#panelsStayOpen-collapseSix"
                    aria-expanded="false"
                    aria-controls="panelsStayOpen-collapseSix"
                  >
                    How long is a normal recruitment process?
                  </button>
                </h2>
                <div
                  id="panelsStayOpen-collapseSix"
                  class="accordion-collapse collapse"
                  aria-labelledby="panelsStayOpen-headingSix"
                >
                  <div class="accordion-body">
                    We are focused on working fast and efficient and this is catalyzed by our modern
                    platform that simplifies the process for everyone. In order not to risk losing
                    qualified candidates, it is important with an efficient and fast recruitment
                    process.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="black-section">
      <div class="col-md-8 mx-auto">
        <div class="d-flex items-center">
          <img src="https://jobshark.eu/img/mail-logo.png" />
          <div class="text d-flex w-100">
            <div class="w-100">
              <h4>Want to get started?</h4>
              <p>
                Register with us and you will soon be able to review top-level candidates!
              </p>
              <button @click="showFormEvent('employer')" class="btn btn-secondary">
                Recruit Developers
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </section>
</template>

<script>
import PublicNavigation from '@/components/Navigations/PublicNavigation';
import Footer from '@/components/Navigations/PublicFooter';
import IntersectionObserver from '@/components/common/IntersectionObserver';
import axios from 'axios';
import titleMixin from '../../mixins/titleMixin';
import { BRANDS } from '../../constants';
import carousel from 'vue-owl-carousel';
export default {
  mixins: [titleMixin],
  title() {
    return 'Tech Recruiting as a Service | Jobshark';
  },
  description() {
    return 'Jobshark is a unique recruiting service in the cloud. We combine an easy-to-use platform with personal services such as headhunting, social recruiting and qualification.';
  },
  canonicalLink() {
    return 'https://jobshark.eu/tech-recruiting';
  },
  components: {
    PublicNavigation,
    Footer,
    carousel,
    IntersectionObserver,
  },
  data: () => ({
    topCompetences: [],
    inViewport: {
      now: false, // Is some part of the component currently in the viewport?
      fully: false, // Is the component completely in the viewport?
      above: false, // Is any part of the component above the viewport?
      below: false, // Is any part of the component below the viewport?
    },
    showForm: {
      formType: '',
      count: 0,
    },
    isLoading: true,
    isSending: false,
    name: '',
    email: '',
    phone: '',
    company: '',
    message: '',
    reToken: '',
    tracking_code: null,
    brands: BRANDS,
    freelancers: [
      {
        name: 'Adelina',
        photo: 'Adelina.png',
        competence: [
          { id: 1, name: 'UX/UI Designer' },
          { id: 2, name: 'UX/UI Design, Figma, User Personas' },
        ],
      },
      {
        name: 'Aleksandar',
        photo: 'Aleksandar.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Spring, SQL, AWS' },
        ],
      },
      {
        name: 'Branislav',
        photo: 'Branislav.png',
        competence: [
          { id: 1, name: 'Full-stack Developer' },
          { id: 2, name: '.NET, JavaScript, Angular' },
        ],
      },
      {
        name: 'Nikola',
        photo: 'Nikola.png',
        competence: [
          { id: 1, name: 'Android Developer' },
          { id: 2, name: 'Kotlin, Java, Unity3D, MySQL' },
        ],
      },
      {
        name: 'Boban',
        photo: 'Boban.png',
        competence: [
          { id: 1, name: 'Java Developer' },
          { id: 2, name: 'Java, Spring Boot, SQL, Azure' },
        ],
      },
      {
        name: 'Filip',
        photo: 'Filip.png',
        competence: [
          { id: 1, name: '.NET Developer' },
          { id: 2, name: '.NET Core, SQL, JavaScript, React Native' },
        ],
      },
      {
        name: 'Haris',
        photo: 'Haris.png',
        competence: [
          { id: 1, name: 'Development Team Lead' },
          { id: 2, name: 'Java, Python, .NET, SQL' },
        ],
      },
    ],
    reviews: [
      {
        id: 1,
        company: 'HR Manager & Co-founder at Footway',
        logo: 'Footway.png',
        review:
          '“As a growth company we needed an active and service minded partner on the HR side. We found that in Jobshark and are very pleased with our collaboration.”',
      },
      {
        id: 2,
        company: 'Game Producer at Filimundus',
        logo: 'Filimundus.png',
        review:
          '“Jobshark provided us with much better results than other jobsites that we have used. Their platform is very easy to use and simplifies the entire recruiting process.”',
      },
      {
        id: 3,
        company: 'Head of Development at Tradedoubler',
        logo: 'Tradedoubler-1024x123.png',
        review:
          '“Building a really strong tech team is crucial for all software companies. I can honestly say that our long-term collaboration with Jobshark has helped us to reach there.”',
      },
      {
        id: 4,
        company: 'HR Business Partner at Sokigo',
        logo: 'sokigo.png',
        review:
          '“In recruitment you need to truly understand the business needs of your organization. Jobshark has an ability to do that, and we’ve had a great collaboration over many years.”',
      },
      {
        id: 5,
        company: 'Manager Technical Ops and Infrastructure at Sovos',
        logo: 'sovos.png',
        review:
          '“At Sovos, we look for the right technical competence no matter where these individuals are based. Jobshark is a great partner to facilitate that.”',
      },
    ],
  }),
  methods: {
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    handleClick() {
      this.$refs.form.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    },

    onIntersectionElement() {
      const colsList = Object.keys(this.$refs);

      colsList.forEach(item => {
        if (this.$refs[item][0] && typeof this.$refs[item][0].play === 'function') {
          this.$refs[item][0].play();
        }
      });
    },
    theFormat(number) {
      return number.toFixed(0);

      /* return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','); */
    },
    completed() {
      //  console.log('Animation ends!');
    },
    playAnimation(col) {
      this.$refs[col].play();
    },
    getTopTenCompetences() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/competence/topcompetences`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          this.topCompetences = data;
          /*   if (window.innerWidth >= 601 && window.innerWidth <= 768) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth <= 601) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth >= 769 && window.innerWidth <= 992) {
            this.topCompetences = data.slice(0, -4);
          }
          if (window.innerWidth > 1000) {
            this.topCompetences = data.slice(0, -1);
          } */
        });
    },
  },
  mounted() {
    this.getTopTenCompetences();
    if (this.$route.query.utm_id) {
      this.tracking_code = this.$route.query.utm_id;
    }
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function(popoverTriggerEl) {
      return new bootstrap.Popover(popoverTriggerEl);
    });
  },
};
</script>
<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.reviews {
  position: relative;
  border-radius: 22px;
  background-color: rgb(242, 102, 34);
  margin-top: 40px;
  margin-bottom: 20px;
  padding: 40px;
  .review-item {
    text-align: center;
    display: block;
    img {
      width: 180px;
      height: auto;
      display: block;
      margin: 0 auto 30px auto;
      filter: grayscale(100%);
    }
    p {
      color: #fff;
      font-size: 21px;
      font-style: italic;
    }
    span {
      display: block;
      color: #fff;
      font-weight: 700;
      margin: 30px 0;
      font-size: 18px;
    }
  }
}

.table-section {
  margin-top: 80px;
  .spanner {
    position: absolute;
    right: 12px;
    top: 12px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 0;
    background: #f05b01;
    font-size: 13px;
    width: 21px;
    height: 21px;
    border-radius: 100%;
    font-weight: 600;
    text-decoration: none;
  }
  p {
    span {
      font-weight: 700;
    }
  }
  .table-bordered {
    /*     td {
      border: 3px solid #fff;
    } */
  }
  table {
    thead {
      tr {
        th {
          color: #fff;
          &:first-of-type {
            background: #fff;
            color: #fff;
          }
          &:not(:first-child) {
            background: #f05b01;
            text-align: center;
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 500;
          position: relative;
        }
        td {
          text-align: center;
        }
        &:nth-child(odd) {
          background: rgba(255, 217, 196, 255);
        }
        &:nth-child(even) {
          background: #ffbe94;
        }
        &:last-of-type {
          color: #fff;
          th {
            font-weight: 600;
          }
          background: #f05b01 !important;
          font-weight: 600;
        }
      }
    }
  }
}

.recruitment {
  padding: 60px 0;
  h3 {
    font-family: $font-family-sans-lato;
    font-weight: 700;
    font-size: 21px;
    color: #575757;
    margin: 20px 0 12px 0;
  }

  .list-unstyled {
    font-family: $font-family-sans-lato;
    color: #575757;
    li {
      margin: 0 0 12px 30px;
      display: flex;
      align-items: center;
      &.first {
        margin-top: 50px;
        margin-left: 0;
        list-style-type: none;
      }
      .icon {
        margin-right: 10px;
      }
      i {
        color: #f26622;
        font-size: 14px;
      }
    }
  }
}
.grey {
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}
.container {
  max-width: 1320px;
}
h2 {
  text-transform: uppercase;
  font-size: 28px;
  margin-bottom: 15px;
}

p {
  color: #575757;
  font-size: 16px;
  font-family: $font-family-sans-lato;
}
.main-header {
  height: 70vh;
  background: url('../../../public/img/homepage/header-services.png');
  background-size: cover;
  margin-top: 70px;
  .container {
    position: relative;
    height: 70vh;
    flex-wrap: wrap;
    h1 {
      color: #fff;
      font-size: 2.5rem;
      width: 100%;
      span {
        display: block;
      }
    }
    p {
      color: #fff !important;
      font-size: 18px;
      font-weight: 400;
    }
    .btn-secondary {
      padding: 10px 55px;
      font-size: 16px;
      font-weight: 500;
      border-radius: 6px;
      &:nth-of-type(2) {
        color: #000;
        margin-left: 12px;
        background: #fff;
        border: none !important;
      }
    }
  }
  .container-col {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: flex-end;
  }
  .list-inline {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
}

.clouds {
  background-image: linear-gradient(to bottom, #008fb2, white);
  min-height: 620px;
  padding: 80px 20px;
  .col-md-4 {
    position: relative;
    height: 460px;
  }
  .text-item {
    h3 {
      color: #fff;
      text-align: center;
      font-weight: 700;
      font-size: 24px;
      margin-bottom: 40px;
    }
    .text-buble {
      background-color: #fff;
      padding: 32px 0px;
      border-radius: 42px;
      text-align: center;
      .price {
        font-size: 32px;
        font-weight: 700;
        margin: 0 0 30px 0;
        span {
          display: block;
          font-weight: 400;
          font-size: 14px;
          color: #666;
        }
      }
      .btn-secondary {
        font-weight: 600;
      }
    }
  }
  .cloud {
    background: rgba(255, 255, 255, 0.9);
    width: 300px;
    height: 100px;
    border-radius: 150px;
    box-shadow: 10px 10px rgba(0, 0, 0, 0.2);
    animation: move 3s infinite;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    padding: 0 12px;
  }

  .cloud:after {
    content: '';
    background: rgba(255, 255, 255, 0.9);
    position: absolute;
    width: 100px;
    height: 100px;
    border-radius: 50%;
    top: -50px;
    left: 50px;
    z-index: -1;
  }

  .cloud:before {
    content: '';
    background: rgba(255, 255, 255, 0.9);
    position: absolute;
    width: 170px;
    height: 150px;
    border-radius: 50%;
    top: -90px;
    right: 40px;
    z-index: -1;
  }

  @keyframes move {
    0% {
      transform: translatex(0);
    }
    50% {
      transform: translatex(-10px);
    }
  }
  .reviews {
    position: relative;
    border-radius: 22px;
    background-color: rgb(242, 102, 34);
    margin-top: -40px;
    padding: 40px;
    .review-item {
      text-align: center;
      display: block;
      img {
        width: 180px;
        height: auto;
        display: block;
        margin: 0 auto 30px auto;
      }
      p {
        color: #fff;
        font-size: 21px;
        font-style: italic;
      }
      span {
        display: block;
        color: #fff;
        font-weight: 700;
        margin: 30px 0;
        font-size: 18px;
      }
    }
  }
}

.about {
  padding: 60px 0;
  h2 {
    text-transform: uppercase;
    font-weight: 500;
    text-align: center;
    font-size: 31px;
  }
  h4 {
    text-align: center;
    margin-top: 40px;
    margin-bottom: 30px;
    font-size: 32px;
    color: #666;
  }
  .title-text {
    text-align: center;
    font-size: 19px;
    span {
      display: block;
    }
  }
  .text-box {
    margin: 40px 0;
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 0 20px 0;
      img {
        width: 72px;
        height: 72px;
        margin-right: 15px;
        object-fit: cover;
      }
      h3 {
        color: #000;
        font-size: 21px;

        text-transform: uppercase;
        font-weight: 700;
        align-self: flex-end;
      }
    }
    .text {
      text-align: center;
      p {
        font-size: 16px;
      }
    }
  }
  .boxes {
    margin-top: 180px;
    .how-box {
      text-align: left;
      position: relative;
      margin-bottom: 100px;
      .text {
        position: relative;
        h2 {
          position: relative;
          z-index: 9;
          text-align: left;
          text-transform: none;
          font-size: 24px;
        }
        p {
          position: relative;
          z-index: 9;
        }
        .count {
          position: absolute;
          bottom: 0;
          right: -80px;
          font-size: 280px;
          font-weight: 900;
          color: #ebeced;
          z-index: 0;
          height: 100px;
          opacity: 0.8;
          line-height: 0;
        }
      }
    }
  }
}

.statistics {
  padding: 20px 0 30px 0;

  h2 {
    margin-bottom: 30px;
  }

  .list-inline {
    margin: 0;
    font-family: $font-family-sans-lato;
    flex-wrap: wrap;

    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      width: 105px;
      height: 105px;
      color: #888;
      border-radius: 6px;
      -webkit-box-shadow: 0px 15px 35px #0000000d;
      box-shadow: 0px 15px 35px #0000000d;
      background: #fff;

      .text {
        width: 100%;

        span {
          display: block;
          margin: 4px auto;
          font-weight: 700;
          color: #575757;
        }

        i {
          display: block;
          font-size: 41px;
        }

        img {
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}

.mid-section {
  padding: 80px 0;
  background: #f26622;
  color: #fff;

  h2 {
    text-align: center;
    text-transform: uppercase;
    margin-bottom: 30px;
    position: relative;

    img {
      margin: -12px 10px 0 0;
    }
  }

  p {
    text-align: center;
    color: #fff;
  }

  .btn-secondary {
    background: #fff;
    border-color: #fff;
    margin: 50px auto 0 auto;
    padding: 8px 25px;
    width: auto;
    display: block;
    color: #000;
    font-size: 16px;
    font-weight: 500;
  }
}

.mid-section-white {
  padding: 60px 0 60px 0;
  color: #000;
  background: rgba(0, 0, 0, 0.05);
  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
  h3 {
    text-transform: uppercase;
    font-size: 28px;
    margin-bottom: 15px;
  }
  p {
    color: #575757;
    font-size: 16px;
  }
  .list-unstyled {
    li {
      margin-bottom: 12px;
      font-size: 14px;
      font-weight: 600;
      display: flex;
      align-items: center;
      .icon {
        width: 20px;
        margin-right: 12px;
        font-size: 18px;
        color: #f26622;
      }
    }
  }
}

.orange-boxes {
  padding: 80px 0;
  .text-box {
    position: relative;
    background: #f26622;
    padding-bottom: 70%;
    border-radius: 12px;
    text-align: center;
    color: #fff;
    .content {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      h3 {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 5px;
      }
      img {
        width: 94px;
        height: 94px;
        border-radius: 100%;
        display: block;
        margin: 0 auto 12px auto;
      }
    }
  }
}

.contact-us {
  margin-top: 80px;
  h2 {
    text-align: center;
    width: 80%;
    margin: 0 auto;
  }
  form {
    margin: 50px 0;
    .form-group {
      position: relative;
      .form-control {
        border-radius: 8px;
        min-height: 65px;
        font-size: 18px;
        font-family: $font-family-sans-lato;
      }
      span {
        position: absolute;
        display: flex;
        top: 0;
        right: 0;
        padding: 0 25px 0 0;
        height: 100%;
        align-items: center;
        justify-content: center;
        font-size: 21px;
        color: red;
      }
    }
    .btn-secondary {
      padding: 15px 0;
      font-size: 18px;
      margin-top: 20px;
    }
  }
}

.what-we-offer {
  .accordion-item {
    border: none !important;
    border-bottom: 1px solid #ddd !important;
    .accordion-button {
      font-weight: 600;
      font-size: 15px;
    }
  }
  .intro {
    text-align: center;
    padding: 80px 0 20px 0;
    h2 {
      text-transform: uppercase;
      font-weight: 700;
    }
  }
  .text-box {
    text-align: center;
    margin-bottom: 50px;
    .icon {
      display: block;
      width: 92px;
      height: 92px;
      margin: 0 auto 20px auto;
      img {
        width: 92px;
        height: 92px;
        object-fit: cover;
      }
    }
    h3 {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 15px;
    }
  }
}

.black-section {
  height: 360px;
  color: #000 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  img {
    width: 200px;
    height: auto;
    margin-right: 40px;
    flex-shrink: 0;
  }
  .text {
    text-align: right;
    align-items: center;
    h4 {
      color: #000;
      font-weight: 600;
    }
    p {
      font-size: 18px;
      color: #000;
      span {
        display: block;
        color: #f26622;
      }
    }
    .btn-secondary {
      padding: 8px 55px;
      text-transform: uppercase;
      font-weight: 600;
    }
  }
}

@media only screen and (max-width: 992px) {
  .table-section {
    table {
      display: block;
      width: 100%;
      overflow-x: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
  .main-header {
    margin-top: 60px;
    height: auto !important;
    .container {
      height: auto;
      h1 {
        font-size: 28px;
        margin-top: 20px;
      }
      p {
        font-size: 15px;
      }
      .btn-secondary {
        display: block;
        margin: 12px 0 0 0 !important;
      }
    }
    .list-inline {
      position: relative;
      display: block !important;
      width: 100%;
      margin-top: 30px;
      li {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
  .about {
    h4 {
      font-size: 21px;
      font-weight: 600;
    }
  }

  .clouds {
    .col-md-4 {
      height: auto !important;
    }
    .cloud {
      position: relative !important;
      margin: 12px 0 !important;
      &::before {
        display: none !important;
      }
      &::after {
        display: none !important;
      }
    }
    .reviews {
      margin-top: 40px;
      .review-item {
        p {
          font-size: 15px;
        }
        span {
          font-size: 15px;
        }
      }
    }
  }
  .black-section {
    display: block !important;
    margin-top: 80px;
    .text {
      text-align: center !important;
    }
    img {
      display: none !important;
    }
  }

  .boxes {
    .how-box {
      &:first-of-type {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(2) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
      &:nth-of-type(3) {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(4) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
      &:nth-of-type(5) {
        .text {
          margin-bottom: 50px;
        }
      }
      &:nth-of-type(6) {
        .text {
          margin-bottom: 50px;
        }
        .col-md-6 {
          order: 1;
        }
      }
    }
  }
}

@media only screen and (max-width: 1200px) {
  .main-header {
    margin-top: 60px;
    height: auto !important;
    .container {
      height: auto;
      h1 {
        font-size: 28px;
        margin-top: 20px;
      }
      p {
        font-size: 15px;
      }
      .btn-secondary {
        display: block;
        margin: 12px 0 0 0 !important;
      }
    }
    .list-inline {
      position: relative;
      display: block !important;
      width: 100%;
      margin-top: 30px;
      li {
        width: 100%;
        margin-bottom: 12px;
      }
    }
  }
}
</style>
